import { createStore, applyMiddleware } from 'redux';
import { autoRehydrate, persistStore } from 'redux-persist';
import localForage from 'localforage';
import createSagaMiddleware from 'redux-saga';
import { hashHistory } from 'react-router';
import { routerMiddleware } from 'react-router-redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import axios from 'axios';
import config from '../../config';
import rootReducer from './rootReducer';
import rootSaga from './rootSaga';
import { createLogger } from 'redux-logger'

let appVersion = process.env.REACT_APP_APP_VERSION

export default function configureStore() {
  const sagaMiddleware = createSagaMiddleware();

  const middlewares = [sagaMiddleware, routerMiddleware(hashHistory)];

  if (process.env.NODE_ENV === 'development') {
    const logger = createLogger({
      level: 'log'
    })

    if (!process.env.REACT_APP_DISABLE_LOGGER) {
      middlewares.push(logger);
    }
  }

  return new Promise((resolve, reject) => {
    const store = createStore(
      rootReducer,
      window.__PRELOADED_STATE__,
      composeWithDevTools(autoRehydrate(), applyMiddleware(...middlewares))
    );

    sagaMiddleware.run(rootSaga);

    try {
      persistStore(
        store,
        {
          keyPrefix: 'majak_' + appVersion + '_',
          storage: localForage,
          blacklist: ['spinner', 'modal', 'settings'],
        },
        () => {
          delete window.__PRELOADED_STATE__;
          resolve(store);
        }
      );
    } catch (e) {
      reject(e);
    }
  });
}

export async function fetchSettings() {
  return axios
    .get(`${process.env.REACT_APP_API_URL}/setting/?pageSize=${config.defaultPageSize}`, {
      responseType: 'json',
    })
    .then(response => {
      window.__PRELOADED_STATE__ = window.__PRELOADED_STATE__ || {};
      window.__PRELOADED_STATE__.settings = {
        settings: response.data.data.reduce((newState, setting) => {
          newState[setting.key] = setting.value;
          return newState;
        }, {}),
      };
    });
}



// WEBPACK FOOTER //
// ./src/app/store/configureStore.js